
import {
  HERO_PANEL,
  HERO_RESERVED,
  heroVehicle,
  heroVehicleIcon,
} from '@/utils/home'

export default {
  name: 'HomeVehicleQuickAccess',
  data() {
    return {
      hasSelectedVehicleCookie: Boolean(
        this.$nuxtCookies.get('selected_vehicle')
      ),
      searching: false,
      modes: {
        panel: HERO_PANEL,
        reserved: HERO_RESERVED,
      },
    }
  },
  computed: {
    vehiclePhoto() {
      const vehicle = this.hero.vehicle
      if (!vehicle) return null
      const image =
        vehicle.image ||
        this.$store.getters.vehicle_search_history.find(
          entry => entry.id === vehicle.id && entry.image?.url
        )?.image
      if (!image?.url) return null
      return this.$cropUrl(image, 240, '_', image.extension, 85)
    },
    hero() {
      return heroVehicle({
        selectedVehicle: this.$store.getters.selected_vehicle,
        history: this.$store.getters.vehicle_search_history,
        hasSelectedVehicleCookie: this.hasSelectedVehicleCookie,
        restored: this.$store.getters.selected_vehicle_restored,
      })
    },
  },
  methods: {
    brandLogo(vehicle) {
      const image = vehicle.brand?.image
      if (!image?.url) return null
      return this.$logoUrl(image, 144, 144, image.extension, 90)
    },
    vehicleIcon(vehicle) {
      return heroVehicleIcon(vehicle)
    },
    vehicleLabel(vehicle) {
      return `${vehicle.brand?.name || ''} ${vehicle.name}`.trim()
    },
    vehicleYears(vehicle) {
      if (!vehicle.year_from) return ''
      return vehicle.year_to
        ? `${vehicle.year_from}–${vehicle.year_to}`
        : `${vehicle.year_from}`
    },
    vehicleUrl(vehicle) {
      if (!vehicle.brand) return '#'
      return this.localePath({
        name: 'recherche-led-accessoires-brand-type-typeid',
        params: {
          brand: this.$slugify(vehicle.brand.name).toLowerCase(),
          type: this.$slugify(vehicle.name).toLowerCase(),
          typeid: vehicle.id,
        },
      })
    },
    selectVehicle(vehicle) {
      this.$store.dispatch('setSelectedVehicle', vehicle)
    },
  },
}
